/**
 * outboxService.js
 * The retry queue for system emails about individual accounts — welcome notes,
 * deactivation notices and the like.
 *
 * Kept separate from campaignService because these are two different things:
 * campaigns are broadcasts someone writes and sends, this is the platform's own
 * mail retrying itself after a delivery failure.
 */

import { RBAC_ENDPOINTS } from '../config/api';
import { rbacFetch } from '../utils/apiClient';

async function parseResponse(res) {
  let json = null;
  try {
    json = await res.json();
  } catch {
    // Gateway errors can come back as HTML — fall through to the status code
  }
  if (!res.ok) {
    throw new Error(json?.message || `Request failed (${res.status})`);
  }
  return json?.data;
}

/** Counts plus the pending/failed rows behind them */
export async function fetchEmailOutbox({ limit = 50 } = {}) {
  const res = await rbacFetch(`${RBAC_ENDPOINTS.emailOutbox}?limit=${limit}`);
  return parseResponse(res);
}

/** Re-queue one email and attempt it immediately */
export async function retryOutboxEmail(id) {
  const res = await rbacFetch(RBAC_ENDPOINTS.emailOutboxRetry(id), { method: 'POST' });
  return parseResponse(res);
}
